export default __webpack_public_path__ + "static/media/left.e0858b8b.png";